import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import icons from "../utils/Icons";
import { setName } from "../store/slices/filterSlice";
import { useDispatch, useSelector } from "react-redux";
var SearchBar = function () {
    var _a;
    var filter = useSelector(function (state) { return state.filter; });
    var searchValue = (_a = filter.name) !== null && _a !== void 0 ? _a : '';
    var _b = useState(false), showSearchReset = _b[0], setShowSearchReset = _b[1];
    var dispatch = useDispatch();
    var searchInputHandle = function (e) {
        dispatch(setName(e.target.value));
    };
    var searchFocusHandle = function () { };
    // const searchBlurHandle = () => {
    //     setShowSearchReset(false);
    // };
    var resetSearchHandle = function () {
        dispatch(setName(undefined));
        setShowSearchReset(false);
    };
    return (_jsxs("div", { className: "bg-white shadow-button-inner flex items-center p-2 h-[44px] rounded-[10px] border  w-full mr-4 border-[#EAEAEC]", children: [_jsx("img", { src: "./images/search-icon-black.png", alt: "" }), _jsx("input", { value: searchValue, onChange: function (e) { return searchInputHandle(e); }, type: "text", className: "bg-white w-full text-[16px] font-[400] outline-none px-3", placeholder: "Name" }), showSearchReset && (_jsx("button", { className: "text-slate-400", onClick: function () { return resetSearchHandle(); }, children: _jsx("img", { src: icons.closeBlack, alt: "" }) }))] }));
};
export default SearchBar;
